/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tool_Grants_All_Tools_Hint_SeparateInputs */



/**
* | output |
* | --- |
* | "Every tool this connection offers now, and every tool it offers in the future. Direct API access is granted on its own." |
*
* @param {Spaces_Tool_Grants_All_Tools_Hint_SeparateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_all_tools_hint_separate = /** @type {((inputs?: Spaces_Tool_Grants_All_Tools_Hint_SeparateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_All_Tools_Hint_SeparateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jedes Tool, das diese Verbindung jetzt anbietet, und jedes, das sie künftig anbietet. Direkter API-Zugriff wird separat freigegeben.")
	return /** @type {LocalizedString} */ ("Every tool this connection offers now, and every tool it offers in the future. Direct API access is granted on its own.")
});